import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import PrivacyContent from "./PrivacyContent";

const Privacy: React.FC = () => {
  useEffect(() => {
    document.title = "Privacy Policy | Send Updates AI";
  }, []);

  return (
    <div className="bg-light py-5">
      <Container style={{ maxWidth: 900 }}>
        <PrivacyContent />
      </Container>
    </div>
  );
};

export default Privacy;
